import React, { useContext } from "react";
import BiotechLogo from "../../../resources/images/Biotech Pharmaceuticals logo.png";
import Typed from "react-typed";
import { LanguageContext } from "../../../Contexts/LanguageContext";

const AboutDetails = () => {
  const [isBangla, setIsBangla] = useContext(LanguageContext);
  return (
    <div className="m-auto container text-center">
      <h2 className="mt-3 mb-3 text-left" style={{ color: "#4871FF" }}>
        <Typed
          strings={["About Us"]}
          typeSpeed={70}
          startDelay={400}
          onComplete={(self) => self.cursor.remove()}
        />
      </h2>
      <img className="mt-5 mb-2" src={BiotechLogo} alt="Biotech" width="200" />
      <div className="row">
        <h4 className="mt-5 col-md-12">
          {isBangla ? (
            <>
              <span style={{ color: "#4871FF" }}>
                Biotech Pharmaceuticals (AY)
              </span>{" "}
              একটি বাংলাদেশ সরকার নিবন্ধনকৃত আয়ুরবেদিক কোম্পানি।
            </>
          ) : (
            <>
              <span style={{ color: "#093eec" }}>
                Biotech Pharmaceuticals (AY)
              </span>{" "}
              is a Bangladesh government registered ayurvedic company.
            </>
          )}
        </h4>
        <div className="col-md-6">
          <div className="text-box text-left">
            <h5 className="mt-5">
              {isBangla
                ? `আমরা আপনাকে মান সম্পন্ন প্রাকৃতিক ঔষধ দিতে চাই।
                আমরা আমাদের ঔষধের জন্য মানসম্পন্ন উপাদান ব্যবহার করি এবং সম্পূর্ণ বিশ্ব
                থেকে হারবস এবং হারবসের নির্যাস ব্যাবহার করি।`
                : `Our mission is to provide high quality natural medicines for you.
                We are using quality ingredients for our medicines and collecting
                herbs and herbal extracts from all over the world.`}
            </h5>
            <h5 className="mt-4">
              {isBangla
                ? "আমাদের Reaserch & Development টিম প্রোডাক্ট ডেভেলপমেন্ট নিয়ে কাজ করছে, নতুন উদ্ভাবন এবং মান নিয়ন্ত্রণের জন্য ধারাবাহিকভাবে কাজ করে যাচ্ছে।"
                : "Our research & development team continuously working for product development, new innovations and quality controls."}
            </h5>
            <h5 className="mt-4">
              {isBangla
                ? "আমরা প্রচলিত আয়ুর্বেদের সাথে প্রযুক্তিকে মিশাতে চাই।"
                : "Our vision is to mix traditional ayurveda with technology."}
            </h5>
          </div>
        </div>
        <div className="col-md-6 text-left">
          <h5
            className="mt-5"
            style={{
              textTransform: "capitalize",
              lineHeight: "28px",
              fontSize: "22px",
            }}
          >
            {isBangla ? `এখনও বহু সংস্কৃতিতে ঔষধি উদ্দেশ্যে ভেষজ ব্যবহার করা হয়।
            পশ্চিম এবং মধ্য আফ্রিকাতে Shrub Ibogaর ছাল কম মাত্রায় উত্তেজক হিসেবে ব্যবহৃত হয় এবং
            বড় হ্যালুসিনোজেন হিসাবে ব্যবহৃত হয়। দক্ষিণ আফ্রিকার ভেষজ বুচু প্রয়োজনীয় তেলগুলি এবং 
            একাধিক হজম ও মূত্র সমস্যার জন্য ঐতিহ্যবাহি প্রতিকার হিসাবে অনেক মূল্যবান।
            উত্তর আমেরিকায় অন্যান্য প্রচলিত ভেষজগুলো থেকে আমরা বেছে নিতে পারি শামান।
            আমরা প্রাচীন আয়ুর্বেদকে আধুনিক ভেষজ ঔষধের সাথে মেশানোর জন্য কাজ করছি।`
            : 
            `Herbs are still used in many cultures for medicinal purposes. In
            West and Central Africa, the root bark of the shrub iboga is used as
            both a stimulant in low doses and as a hallucinogen in larger
            quantities. The South African herb buchu is valued for its essential
            oils and as a traditional remedy for a number of digestive and
            urinary problems. In North America, the shaman could choose from
            many other traditional herbal remedies. So, Biotech team is working
            to breeze ancient ayurveda with modern herbal medicine.`}
          </h5>
        </div>
      </div>
    </div>
  );
};

export default AboutDetails;
